<template>
  <confirm-dialog
    :display="displayModal"
    :message="$t('page.selection.confirm.message')"
    @accepted="confirmLeaving()"
    @cancelled="abortLeaving()"
  ></confirm-dialog>
</template>

<script lang="ts">
import Vue from 'vue';
import ConfirmDialog from '@/components/interface/confirm-dialog.vue';
import { Nullable } from '@/models/type-generators/nullable';

export default Vue.extend({
  name: 'ThePurchaseConditionSelectionConfirmDialog',
  components: {
    ConfirmDialog
  },
  props: {
    pendingRedirection: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      displayModal: false
    };
  },
  methods: {
    confirmLeaving() {
      this.closeModalAndRedirect();
    },
    abortLeaving() {
      this.closeModalAndRedirect(false);
    },
    closeModalAndRedirect(redirect?: false) {
      this.displayModal = false;
      if (this.pendingRedirection) {
        this.pendingRedirection(redirect);
      }
    }
  },
  watch: {
    pendingRedirection: {
      immediate: true,
      handler(newValue: Nullable<Function>) {
        this.displayModal = newValue != null;
      }
    }
  }
});
</script>
